import { formatDate } from "../../helpers/formatDate";
import {
    getCompletionSubLabel,
    getDueDateStatusFromDate,
    getDueDateSubLabel,
} from "../../helpers/dueDateStatus";
import { getNormalizedReportStatus } from "../../helpers/reportStatusOptions";

const ServiceDueDateCell = ({
    dueDate,
    status,
    dueDateColorClass,
    dueDateSubLabel,
    completionLabel,
    completionDate,
    href,
}) => {
    if (!dueDate) {
        return (
            <span className="text-slate-500 whitespace-nowrap">
                Not Assigned
            </span>
        );
    }

    const normalizedStatus = getNormalizedReportStatus(status);
    const isComplete =
        normalizedStatus === "complete" || normalizedStatus === 2;
    const isTodoOrInProgress =
        normalizedStatus === "to do" ||
        normalizedStatus === "in progress" ||
        normalizedStatus === 0 ||
        normalizedStatus === 1;
    const resolvedDueDateSubLabel =
        dueDateSubLabel || getDueDateSubLabel(dueDate, status);
    const resolvedCompletionLabel =
        completionLabel ||
        getCompletionSubLabel(dueDate, completionDate, status);
    const showDueSubLabel =
        isTodoOrInProgress && !!resolvedDueDateSubLabel;
    const showCompletionSubLabel =
        isComplete && !!resolvedCompletionLabel;
    const badgeColorClass = isComplete
        ? "bg-slate-500"
        : dueDateColorClass ||
          getDueDateStatusFromDate(dueDate)?.bgClass ||
          "bg-slate-400";

    const content = (
        <>
            <span
                className={`inline-flex items-center rounded-full px-2.5 py-0.5 text-md font-medium text-white ${badgeColorClass}`}
            >
                {formatDate(dueDate, { dateStyle: "short" })}
            </span>

            {showDueSubLabel && (
                <span className="mt-1 text-xs font-medium whitespace-nowrap text-slate-600">
                    {resolvedDueDateSubLabel}
                </span>
            )}

            {showCompletionSubLabel && (
                <span className="mt-1 text-xs font-medium whitespace-nowrap text-slate-600">
                    {resolvedCompletionLabel}
                </span>
            )}
        </>
    );

    return href ? (
        <a
            rel="noreferrer"
            href={href}
            className="inline-flex min-w-[110px] flex-col items-start whitespace-nowrap"
        >
            {content}
        </a>
    ) : (
        <span className="inline-flex min-w-[110px] flex-col items-start whitespace-nowrap">
            {content}
        </span>
    );
};

export default ServiceDueDateCell;
